import React from 'react';
import ImageButtonSettings from '../../../Components/ImageButtonSettings';

const ImageButtonWidgetSettings = ({ edit, setEdit, t }) => {
  if (!(edit.dataId > 0 && edit.type === 'image-button')) {
    return null;
  }

  return (
    <div>
      <h4 className='form-lbl' style={{ color: 'var(--header-color)', marginTop: '20px' }}>{t.imagesHeading}</h4>
      <ImageButtonSettings edit={edit} setEdit={setEdit} />
    </div>
  );
};

export default ImageButtonWidgetSettings;
